"use strict";

/* eslint no-undef: "off" */
/**
 * search panel
 */
define('headerNavbar',['busEvent'], function (busEvent) {
    return {
        template: "\n        <div class=\"xp-navbar-container\" :class=\"{ 'xp-navbar-light': light }\">\n            <div class=\"xp-navbar-left-content\">\n                <i @click=\"onBackBtnClicked\" class=\"xp-iconfont xp-icon-arrow-left\"></i>\n            </div>\n            <div  class=\"xp-navbar-content\">\n                <p v-if=\"title\" v-text=\"title\"></p>\n                <slot name=\"title\"></slot>\n            </div>\n            <div v-if=\"showMenuBtn\" class=\"xp-navbar-right-content\">\n                <slot name=\"menu\"></slot>\n            </div>\n        </div>\n      ",
        data: function data() {
            return {};
        },

        props: {
            showBackBtn: {
                type: Boolean,
                default: true
            },
            title: {
                type: String,
                default: ""
            },
            showMenuBtn: {
                type: Boolean,
                default: false
            },
            customBack: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: false
            }
        },
        mounted: function mounted() {},

        methods: {
            onBackBtnClicked: function onBackBtnClicked() {
                // 自定义返回按钮的处理
                if (this.customBack) {
                    this.$emit("backBtnClicked");
                } else {
                    history.back();
                }
            }
        }
    };
});
